<template>
	<div class="search-product">
		<div class="el-search vue-top-padding">
			<div class="el-left">
				<el-button
					type="primary"
					size="small"
					v-hasPerm="['product:insert']"
					icon="el-icon-plus"
					@click="addProduct"
					style="margin: 0;"
					>{{ $t("common.add") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					ref="product"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item prop="typeName" style="margin: 0 10px 0 0;">
						<el-input
							v-model="search.typeName"
							:placeholder="$t('searchProduct.productTypeName')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item prop="name" style="margin: 0 10px 0 0;">
						<el-input
							v-model="search.name"
							:placeholder="$t('searchProduct.goodsName')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item prop="no" style="margin: 0 10px 0 0;">
						<el-input
							v-model="search.no"
							:placeholder="$t('searchProduct.code')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item style="margin: 0;">
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button @click="resetSearch('product')" icon="el-icon-refresh">{{
							$t("common.reset")
						}}</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchProduct",
	props: {
		search: Object,
	},
	data() {
		return {};
	},
	methods: {
		addProduct() {
			this.$emit("addProduct");
		},
		onSubmit() {
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
	},
};
</script>

<style lang="sass"></style>
